<script setup>
import SurveyTable from '@/views/survey/SurveyTable2.vue'

// import SurveyCompletionDashboard from '@/views/survey/dashboard/SurveyCompletionDashboard.vue'
// import SurveyResponseAnalytics from '@/views/survey/dashboard/SurveyResponseAnalytics.vue'

definePage({
  meta: {
    name: 'survey-entry-patient',
    subject: 'survey.menu',
    action: 'survey_entry_patient',
  },  
})
</script>

<template>
  <div>
    <VRow>
      <!-- page title -->
      <VCol cols="12">
        <span class="text-h3 font-weight-bold text-primary text-capitalize">
          Patient Survey
        </span>
        <p class="text-body-2">
          Manage & analyze patient's Survey
        </p>
      </VCol>
      <!--
        <VCol cols="6">
        <SurveyCompletionDashboard />
        </VCol>
        <VCol cols="6">
        <SurveyResponseAnalytics />
        </VCol> 
      -->
    </VRow>
    <SurveyTable
      class="mt-3"
      page-type="Customer"
    />
  </div>
</template>
